module.exports = __webpack_public_path__ + "static/media/pinholster_fenton_kr_dan.b2904df7.jpg";